import { emojiIndex } from 'emoji-mart';
import emojiData from 'emoji-mart/data/all.json';
import twemoji from '@twemoji/api';

const aliases = {};
for (const [id, entry] of Object.entries(emojiData.emojis)) {
	for (const alias of entry.short_names || []) aliases[alias] = id;
}

export function resolveEmoji(value, skin = 1) {
	if (value && typeof value === 'object') {
		if (value.native) return value;
		skin = value.skin || skin;
		value = value.id;
	}
	if (typeof value !== 'string') return null;
	const match = value.match(/^:?([\w+-]+):?(?::skin-tone-([2-6]):)?$/);
	if (match) {
		const entry = emojiIndex.emojis[aliases[match[1]] || match[1]];
		if (entry) return entry.native ? entry : entry[Number(match[2]) || skin] || entry[1];
	}
	if (twemoji.test(value) && twemoji.replace(value, () => '') === '') return { native: value, id: value };
	return null;
}

export function emojiAssetPath(native) {
	// Variation selectors are kept inside joined sequences, as required by Twemoji.
	if (native === '👁️‍🗨️') native = '👁‍🗨';
	const normalized = native.includes('\u200d') ? native : native.replace(/\ufe0f/g, '');
	return '/images/emoji/twemoji/' + twemoji.convert.toCodePoint(normalized) + '.svg';
}

export function emojiSegments(text) {
	const normalized = String(text).replace(/:([\w+-]+):(?::skin-tone-[2-6]:)?/g, token => resolveEmoji(token)?.native || token);
	const segments = [];
	let position = 0;
	twemoji.replace(normalized, (native, ...argumentsAfterMatch) => {
		const offset = argumentsAfterMatch[argumentsAfterMatch.length - 2];
		if (offset > position) segments.push(normalized.slice(position, offset));
		segments.push({ native });
		position = offset + native.length;
		return native;
	});
	if (position < normalized.length) segments.push(normalized.slice(position));
	return segments;
}

export function isEmojiOnly(text) {
	const segments = emojiSegments(text);
	return segments.some(segment => typeof segment !== 'string' && !/^[\u{1f3fb}-\u{1f3ff}]$/u.test(segment.native)) && segments.every(segment => typeof segment !== 'string' || !segment.trim());
}
